import React, { useEffect, useState } from "react";
import { formatMoney } from "../../../features/utils/formatMoney";
import { getDateRangeFromFilter } from "../../../controllers/commonUIControllers";
import getWalletPayoutStats from "../../../controllers/booking/Transactions.js/getWalletPayoutStats";

function TransactionsPayoutStatsSection({ timeFilter }) {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState({
    total: 0,
    amount: 0,
  });
  const [paid, setPaid] = useState({
    total: 0,
    amount: 0,
  });
  const [pending, setPending] = useState({
    total: 0,
    amount: 0,
  });
  const [cancelled, setCancelled] = useState({
    total: 0,
    amount: 0,
  });
  const items = [
    {
      label: "Total",
      total: total.total,
      amount: total.amount,
    },
    {
      label: "Paid",
      total: paid.total,
      amount: paid.amount,
    },
    {
      label: "Pending",
      total: pending.total,
      amount: pending.amount,
    },
    {
      label: "Cancelled",
      total: cancelled.total,
      amount: cancelled.amount,
    },
  ];

  const loadStats = async () => {
    const { startDate, endDate } = getDateRangeFromFilter(timeFilter);
    setLoading(true);
    await getWalletPayoutStats({ startDate, endDate })
      .then((res) => {
        if (res.return) {
          const defaultItem = { amount: 0, total: 0 };
          const fetchedPaid = res?.data?.paid || defaultItem;
          const fetchedPending = res?.data?.pending || defaultItem;
          const fetchedTotal = res?.data?.payout || defaultItem;
          const fetchedCancelled = res?.data?.failed || defaultItem;

          setPaid(fetchedPaid);
          setPending(fetchedPending);
          setTotal(fetchedTotal);
          setCancelled(fetchedCancelled);
        }
      })
      ?.finally(() => setLoading(false));
  };

  useEffect(() => {
    loadStats();
  }, [timeFilter]);

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 ">
      {items.map((item, itemIndex) => (
        <div
          className="flex flex-1 border-black/10 bg-[#F9F9F9] p-4 rounded-lg flex-col"
          key={itemIndex}
        >
          <div className="w-full flex items-center justify-between">
            <small>{item.label}</small>
            {loading ? (
              <div className="primaryLoader"></div>
            ) : (
              <>
                {item?.total ? (
                  <div className="px-2 rounded-md border-black/10 bg-white border pb-1">
                    {" "}
                    <small>{item.total.toLocaleString()}</small>{" "}
                  </div>
                ) : (
                  <></>
                )}
              </>
            )}
          </div>
          <span>
            {" "}
            {loading ? (
              <div className="primaryLoader"></div>
            ) : (
              formatMoney(item.amount)
            )}
          </span>
        </div>
      ))}
    </div>
  );
}

export default TransactionsPayoutStatsSection;
